import { buf2hex, hex2buf } from "./util";
// import vendors from "./vendors.json";
import vendors from "./real_vendors.json";

// This is implemented weird because I wanted to
// have JEP106 support before I realized that nobody
// implements it.
function findVendor(rdid_bytes) {
	const bytes_hex = buf2hex(rdid_bytes).toUpperCase();
	// console.log("Bytes in hex:", bytes_hex)
	for(var code in vendors) {
		const vendor = vendors[code]
		// console.log("CODE", code, vendor);
		if(bytes_hex.startsWith(vendor[1])) {
			console.log("Found vendor", vendor[0])
			return vendor[0]
		}
	}
	return null;
}

export default findVendor;